import { graphql } from "@/lib/gql/__generated__/gql";

export const RoomList_ListPage_Query = graphql(/* GraphQL */ `
	query RoomList_ListPage($hotelID: ID!) {
		roomList(hotelID: $hotelID) {
			dummy {
				capacityAdultMaximum
				capacityKidsMaximum
				capacityPeopleMaximum
				catchCopy
				availablePlanIDs
				description
				hotelID
				id
				inSale
				isKidsUnavailable
				keyVisuals {
					bucket
					fileName
					key
					mimeType
					region
				}
				kidsPolicy {
					kidsDiscountType
					kidsMaxAge
					ratio
					static {
						amount
						currencyType
					}
				}
				mainKeyVisual {
					bucket
					fileName
					key
					mimeType
					region
				}
				maxRoomNum
				name
				roomID
			}
			hotelID
			id
			rooms {
				address {
					city
					nationality
					other
					postalCode
					pref
					state
					town
				}
				amenities
				availablePlanIDs
				tags
				tagsLocation
				article {
					bucket
					fileName
					key
					mimeType
					region
				}
				articleTitle
				beds {
					bedNum
					bedType
				}
				capacityAdultMaximum
				capacityKidsMaximum
				capacityPeopleMaximum
				catchCopy
				description
				geoLocation {
					lat
					lon
				}
				hotelID
				id
				inSale
				isDormitoryType
				isExtendSiteControllerPeopleNum
				isKidsUnavailable
				isNotDiscountTarget
				maxRoomNum
				name
				overSiteControllerPeopleNum {
					availableWeekDays
					prices {
						price {
							amount
							currencyType
						}
						upperNum
					}
				}
				requiredPrepMillisecond
				roomID
				roomSize
				saleTypeForPlan
				keyVisuals {
					bucket
					fileName
					key
					mimeType
					region
				}
				kidsPolicy {
					kidsDiscountType
					kidsMaxAge
					ratio
					static {
						amount
						currencyType
					}
				}
				mainKeyVisual {
					bucket
					fileName
					key
					mimeType
					region
				}
			}
		}
	}
`);
